import type { ReactNode } from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import HealingOutlinedIcon from '@mui/icons-material/HealingOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import VaccinesOutlinedIcon from '@mui/icons-material/VaccinesOutlined';
import EmergencyOutlinedIcon from '@mui/icons-material/EmergencyOutlined';

/**
 * Per-claim-type icons (small, gray). Shared by the claim-type tile grid
 * (ClaimTypeSection) and the stacked bill-type card (ClaimBillTypeCard).
 */
export const CLAIM_TYPE_ICONS: Record<string, ReactNode> = {
  OFFICE_VISIT: <DescriptionOutlinedIcon fontSize="small" />,
  OFFICE_PROCEDURE: <MedicalServicesOutlinedIcon fontSize="small" />,
  HOSPITAL_CONSULT: <LocalHospitalOutlinedIcon fontSize="small" />,
  SURGICAL: <HealingOutlinedIcon fontSize="small" />,
  ANESTHESIA: <VaccinesOutlinedIcon fontSize="small" />,
  PATHOLOGY: <BiotechOutlinedIcon fontSize="small" />,
  NEUROMONITORING: <PsychologyOutlinedIcon fontSize="small" />,
  FACILITY: <BusinessOutlinedIcon fontSize="small" />,
  ER_CONSULT: <EmergencyOutlinedIcon fontSize="small" />,
};

/** Icon for a claim type, falling back to the generic description icon. */
export function getClaimTypeIcon(code: string): ReactNode {
  return CLAIM_TYPE_ICONS[code] ?? <DescriptionOutlinedIcon fontSize="small" />;
}
